import {
    Box,
    CardContent,
    Grid,
    Typography,
    CardActions,
    Divider,
    Card,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ApexCharts from "react-apexcharts";
import bannerBg from "../../assets/images/home/home-banner-bg.svg";
import { makeStyles } from "@mui/styles";
import cssVariables from "../../theme/cssVariables";
import React, { useEffect } from "react";
import planningImg from "../../assets/images/home/planning.svg";
import { ReactComponent as Edit } from "../../assets/images/home/pen.svg";
import fileBrowser from "../../icons/file-browser.svg";

const useStyles = makeStyles({
    media: {
        height: 200,
    },
    clickable: {
        cursor: "pointer",
        textAlign: "center",
        transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        '&:hover': {
            color: 'rgb(65, 112, 105) !important'
        }
    },
    iconContainer: {
        width: 40,
        height: 40,
        borderRadius: 5,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    blueBg: {
        background: "#6694CC",
    },
    purpleBg: {
        background: "#7580BD",
    },
    customCardSize: {
        height: 380,
    },
    cardContentSize: {
        display: "flex",
        justifyContent: "center",
        flexFlow: "column",
        alignItems: "center",
        height: "calc(100% - 130px)",
    },
    styleText: {
        textDecoration: "underline",
        fontWeight: "500",
    },
    styleScroll: {
        color: "#5DA196",
        paddingLeft: "30px",
        paddingRight: "20px",
    },
});
const styles = {
    paperContainer: {
        backgroundImage: `url(${bannerBg})`,
        width: "100%",
        minHeight: 200,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        borderRadius: "10px",
        position: "relative",
    },
    bannerImage: {
        position: "absolute",
        bottom: 0,
        width: "100%",
        maxWidth: "336px",
        height: "auto",
    },
    blueBadge: {
        background: "rgb(83 135 198 / 15%)",
        padding: "2px",
        color: "#5387C6",
    },
    blockGrid: {
        padding: "38px 0 0 0",
    },
    barLegend: {
        fontSize: "14px",
        lineHeight: "19px",
        color: "#939393",
    },
};
function BarLegend(props) {
    const { data, dataBarChart, colors } = props;
    let row = [];
    for (var i = 0; i <= dataBarChart.length - 1; i++) {
        row.push(
            <Box key={i} display="flex" alignItems="center">
                <Box sx={{ width: "5%" }}>
                    <div
                        className="bar-legend-circle"
                        style={{ backgroundColor: colors[i] }}
                    ></div>
                </Box>
                <Box sx={{ width: "50%" }}>
                    <Typography variant="label" style={styles.barLegend} fontWeight={300}> {dataBarChart[i]?.name}</Typography>
                </Box>
                <Box sx={{ width: "15%" }}>
                    <Typography variant="label" style={styles.barLegend} fontWeight={300}> {dataBarChart[i]?.data[0]}</Typography>
                </Box>
                <Box sx={{ width: "15%" }}>
                    <Typography variant="label" style={styles.barLegend} fontWeight={300}> {data.options.unit}</Typography>
                </Box>
                <Box sx={{ width: "15%" }}>
                    <Typography variant="label" style={styles.barLegend} fontWeight={300}>({dataBarChart[i]?.percentage}%)</Typography>
                </Box>
            </Box>
        );
    }
    return row;
}
const BarChartPlanning = (props) => {
    const { t } = useTranslation();
    const { data, title, callBack, path,icon,color} = props;
    const [dataBarChart, setDataBarChart] = React.useState([]);
    const [score, setScore] = React.useState(0);
    const [colorBar, setColor] = React.useState([]);
    const [criterionScore, setcriterionScore] = React.useState(0);

    useEffect(() => {
        if (data.data !== undefined && data.data.length > 0 && data.ratio_data !== undefined && data.ratio_data.length > 0) {
            let sumData = []
            let totalScore = 0
            let criterion_score = 0
            let colors = []
            for (let index = 0; index <= data.data.length - 1; index++) {
                for (let order = 0; order <= data.ratio_data.length - 1; order++) {
                    if (data.data[index]?.serial === Object.keys(data.ratio_data[order])[0]) {
                        let accumulate = Number.isNaN(Number(data.data[index]?.accumulate_use)) ? 0 : Math.round(data.data[index]?.accumulate_use * 100) / 100
                        totalScore = totalScore + Number(data.ratio_data[order][Object.keys(data.ratio_data[order])[0]]?.score) + accumulate
                        criterion_score = data.data[index]?.criterion_score
                        sumData.push({
                            name: data.data[index]?.description,
                            data: [(Math.round((Number(data.ratio_data[order][Object.keys(data.ratio_data[order])[0]]?.score) + accumulate) * 100) / 100).toFixed(2)],
                            percentage: Number.isNaN(Number(data.ratio_data[order][Object.keys(data.ratio_data[order])[0]]?.percentage)) ? 0 : (Math.round(data.ratio_data[order][Object.keys(data.ratio_data[order])[0]]?.percentage * 100) / 100).toFixed(2),
                            accumulate_use: accumulate,
                            is_accumulate: data.data[index]?.is_accumulate,
                            configuration: data.data[index]?.configuration
                        })
                        colors.push(JSON.parse(data.data[index]?.configuration)['background-color'])
                    }
                }
            }
            setScore((totalScore).toFixed(2))
            setDataBarChart(sumData)
            setcriterionScore(criterion_score)
            setColor(colors)
        }
    }, [data]);
    const classes = useStyles();
    let chartOptions = {
        type: "bar",
        color: "#939393",
        options: {
            unit: "คะแนน",
            chart: {
                type: "bar",
                stacked: true,
                stackType: "100%",
                toolbar: {
                    show: false,
                },
                offsetX: 0,
                offsetY: 0,
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    // borderRadius: 20,
                    barHeight: "100%",
                    colors: {
                        ranges: [{
                            from: 0,
                            to: 0,
                            color: '#F0F0F0'
                        }],
                        backgroundBarColors: ['#F0F0F0'],
                        backgroundBarOpacity: 1,
                        backgroundBarRadius: 0,
                    },
                },
            },
            grid: {
                show: false,
                padding: {
                    top: -50,
                    right: 0,
                    bottom: -10,
                    left: -20,
                },
            },
            stroke: {
                width: 0,
                colors: ["#fff"],
            },
            xaxis: {
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
            yaxis: {
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
            dataLabels: {
                enabled: false,
            },
            tooltip: {
                x: {
                    show: false,
                },
                y: {
                    formatter: function (val) {
                        return val + "คะแนน";
                    },
                },
            },
            fill: {
                opacity: 1,
            },
            legend: {
                show: false,
                position: "bottom",
                horizontalAlign: "left",
                offsetX: -33,
                offsetY: -55,
                formatter: function (val, opts) {
                    const roundToHundred = (arr) => {
                        let output = [];
                        let acc = 0;
                        for (let i = 0; i < arr.length; i++) {
                            let roundedCur = Math.round(arr[i][0]);
                            const currentAcc = acc;
                            if (acc == 0) {
                                output.push(roundedCur);
                                acc += arr[i][0];
                                continue;
                            }
                            acc += arr[i][0];
                            output.push(Math.round(acc) - Math.round(currentAcc));
                        }
                        return output;
                    };
                    let roundedVal = roundToHundred(opts.w.globals.seriesPercent);
                    return (
                        "<span class='fs-12px ml-2'>" +
                        (val ? val : "-") +
                        ":</span><span class='fs-12px fw-600 float-right ml-1'>" +
                        (opts.w.globals.series[opts.seriesIndex]
                            ? opts.w.globals.series[opts.seriesIndex]
                            : 0) +
                        " (" +
                        (roundedVal[opts.seriesIndex] ? roundedVal[opts.seriesIndex] : 0) +
                        "%)" +
                        "</span>"
                    );
                    // return (
                    //   "<span class='fs-12px ml-2'>" +
                    //   val +
                    //   "</span><span class='fs-12px fw-600 float-right'>" +
                    //   (roundedVal[opts.seriesIndex] ? roundedVal[opts.seriesIndex] : 0 )+
                    // "% (" +
                    // (opts.w.globals.series[opts.seriesIndex] ? opts.w.globals.series[opts.seriesIndex] : 0) +
                    // ")</span>"
                    // );
                },
            },
        },
    };
    let linkPath = () => {
        if (path !== undefined && path !== null && path !== "") {
            callBack(path)
        }
    }
    return (
        <Card classes={{ root: classes.customCardSize }}>
            <Box px={2} py={1} style={{ height: "100%" }}>
                <CardContent sx={{ paddingLeft: "0px", paddingRight: "0px" }}>
                    <Grid item sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <Grid container spacing={0}>
                            <Grid item>
                                <div
                                    className={`${classes.iconContainer}`}
                                    style={{ background: color }}
                                >
                                    <img src={icon} alt="bannerImage" />
                                </div>
                            </Grid>
                            <Grid item ml={1} display="flex" alignItems="center">
                                <Grid container spacing={0}>
                                    <Grid item>
                                        <Typography
                                            fontSize={20}
                                            lineHeight="22px"
                                            sx={{ fontWeight: "600" }}
                                        >
                                            {title}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Box sx={{ flex: 2 }}></Box>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <Box>
                                {data?.code === "y" ?
                                    <Edit onClick={linkPath} style={{ cursor: "pointer" }} />
                                    : null
                                }
                            </Box>
                        </Box>
                    </Grid>
                </CardContent>
                <Divider />
                {dataBarChart.length > 0 ?
                    <Box>
                        <CardContent
                            className={classes.cardContentSize}
                            sx={{
                                justifyContent: "flex-start",
                                alignItems: "flex-start",
                                padding: "10px 0",
                            }}
                        >
                            <Grid container my={2}>
                                <Grid item lg={6}>
                                    <Typography
                                        fontSize={18}
                                        fontWeight={600}
                                        lineHeight="19.8px"
                                    >
                                        {t("home.label.planningPortion")}
                                    </Typography>
                                </Grid>
                                <Grid item lg={6}>
                                    <Typography
                                        fontSize={18}
                                        fontWeight={500}
                                        lineHeight="24.84px"
                                        textAlign="right"
                                        sx={{ color: "#939393" }}
                                    >
                                        {score > 0 ? "100%" : "0%"}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item lg={12} xs={12}>
                                    <ApexCharts
                                        options={{ ...chartOptions.options, colors: colorBar }}
                                        series={dataBarChart}
                                        type={chartOptions.type}
                                        height="50px"
                                    ></ApexCharts>
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item lg={8} xs={8}>
                                    <Grid container>
                                        <Grid item lg={12} xs={12}>
                                            {Object.keys(dataBarChart).length > 0 ?
                                                <BarLegend data={chartOptions} colors={colorBar} dataBarChart={dataBarChart}></BarLegend>
                                                : null}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item lg={4} xs={4} display="flex" alignItems="flex-start" flexDirection="column">
                                    {dataBarChart.length > 0 ?
                                        dataBarChart.map((loRow, index) => (
                                            loRow.accumulate_use > 0 && loRow.is_accumulate === "y" ?
                                                <Box style={loRow?.configuration !== undefined && loRow?.configuration !== null ? { position: "relative" } : { position: "relative" }}>
                                                    <Box>
                                                        <Typography fontSize={12} lineHeight="18px" fontWeight={500} sx={{ padding: "2px 5px" }} style={loRow?.configuration !== undefined && loRow?.configuration !== null ? { "background-color": `${JSON.parse(loRow?.configuration)['accumulate-color']}`, "color": `${JSON.parse(loRow?.configuration)['accumulate-color']}`, opacity: "0.15" } : {}}>
                                                            ใช้คะแนนสะสม {loRow.accumulate_use} คะแนน
                                                        </Typography>
                                                    </Box>
                                                    <Typography fontSize={12} lineHeight="18px" fontWeight={500} sx={{ padding: "2px 5px" }} style={loRow?.configuration !== undefined && loRow?.configuration !== null ? { position: "absolute", top: 0, "color": `${JSON.parse(loRow?.configuration)['accumulate-color']}` } : {}}>
                                                        ใช้คะแนนสะสม {loRow.accumulate_use} คะแนน
                                                    </Typography>
                                                </Box>
                                                : <Box>
                                                    <Typography fontSize={12} lineHeight="22px" fontWeight={500}>
                                                        &nbsp;
                                                    </Typography>
                                                </Box>
                                        ))
                                        : null}
                                </Grid>
                            </Grid>
                        </CardContent>
                        <Divider variant="middle" />
                        <CardActions>
                            <Grid container mt={0}>
                                <Grid
                                    item
                                    display="flex"
                                    justifyContent="flex-end"
                                    sx={{ flexFlow: "column", marginLeft: "auto" }}
                                >
                                    <Typography
                                        fontSize={16}
                                        lineHeight="24px"
                                        fontWeight={500}
                                        textAlign="right"
                                        sx={{ color: "#939393" }}
                                    >

                                        คะแนนสะสมรวมปัจจุบัน:{" "}
                                        <span className={classes.styleScroll}>{score}</span> คะแนน
                                    </Typography>
                                    <Typography
                                        fontSize={11}
                                        lineHeight="16.5px"
                                        textAlign="left"
                                        sx={{ color: "#939393" }}
                                    >

                                        (ภาระงานขั้นต่ำ {criterionScore} คะแนน)
                                    </Typography>
                                </Grid>
                            </Grid>
                        </CardActions>
                    </Box>
                    :
                    <CardContent className={classes.cardContentSize}>
                        <Box>
                            <img src={fileBrowser} alt="browser" />
                        </Box>
                        {data?.code === "y" ?
                            <Box>
                                <Typography sx={{ color: "#939393" }}>
                                    ยังไม่มีข้อมูล หากต้องการเพิ่มข้อมูลให้ <br />
                                    <Typography
                                        classes={{ root: classes.clickable }}
                                        style={{ color: "#5DA196", fontWeight: "500", textDecoration: "underline" }}
                                        onClick={linkPath}
                                    >
                                        {/* {t("portfolio.label.clickhere")} */}
                                        คลิกที่นี่
                                    </Typography>
                                </Typography>
                            </Box>
                            :
                            <Box>
                                <Typography sx={{ color: "#939393" }}>
                                    ยังไม่มีข้อมูล
                                </Typography>
                            </Box>}
                    </CardContent>
                }
            </Box>
        </Card>
    );
};
export default BarChartPlanning;
